import jsPDF from 'jspdf';
import moment from 'moment';
import { drawCabeceraFiscalEmpresa } from './empresa_pdf';

/* Agregar imagen: addImage ( source, tipo, posicionX, posicionY, ancho, alto) */
/* addImage ( 'img.png', 'PNG', 100, 100, 50, 50) */
/* Agregar texto: text(texto, posicionX, posicionY) (se puede usar setFont, setFontSize, setTextColor, setFontType) */
/* pdf.setFontSize(20); pdf.setFont("times"); pdf.setFontType("bold"); pdf.setTextColor(255, 0, 0); */
/* A4: 210mm x 297 mm */


export default {
  methods: {
    exportFacturaChilePDF (venta, renglones, empresa) {
      let pdfName = 'factura_'; 
      pdfName = pdfName.concat(venta.numero.toString().trim()); 
      /* Parametros: portrait, milimetros, A4 */
      var doc = new jsPDF('p', 'mm', 'a4');

      doc.setProperties({
        title: 'Factura',
        subject: 'Factura',		
        author: 'Cervertti - Marketing & Eventos',
        creator: 'Cervetti'
      });

      // let fontName = 'CenturyGothic';
      // let fontBoldName = 'CenturyGothicBold';
      // let fontItalicName = 'CenturyGothicItalic';
      // let fontBoldItalicName = 'CenturyGothicBoldItalic';

      let fontName = 'Montserrat-Regular';
      let fontBoldName = 'Montserrat-Bold';
      let fontItalicName = 'Montserrat-Italic';
      let fontBoldItalicName = 'Montserrat-BoldItalic';

      // venta.cuit = this.$options.filters.cuit(venta.cuit);
      venta.documentoNumero = this.$options.filters.cuit(venta.documentoNumero);

      /* Limite para el salto de página */
      let positionMaxY = 220;
      /* Limite para incluir totales y datos de facturacion */
      let positionTotalesY = 228;

      /* Interlineado */
      let interlineadoRenglones = 5;
      let interlineadoTotales = 5;

      /* Formato para alinear numeros a la derecha */
      let alignRight = {
        'align': 'right'
      }

      // drawCabecera(doc, empresa, venta, 
      //   fontName, fontBoldName, fontItalicName, fontBoldItalicName);
  
      /* Renglones */
      // let positionY = positionRenglonesY;

      let positionY = drawCabecera(doc, empresa, venta, 
        fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      
      positionY += interlineadoRenglones;

      if (renglones) {
        /* Titulo de los renglones */
        doc.setTextColor(60, 60, 60);
        doc.setFont(fontBoldName, 'bold');
        // doc.setFontType('normal');

        doc.text('Servicio', 10, positionY);
        doc.text('Importe', 200, positionY, alignRight);

        for(let key in renglones) {
          const renglon = renglones[key];

          /* Verificamos si necesitamos agregar una nueva pagina */
          if (positionY + interlineadoRenglones > positionMaxY) {
            /* Agregamos una nueva pagina */
            doc.addPage();

            positionY = drawCabecera(doc, empresa, venta, 
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
            
            positionY += interlineadoRenglones;
          }

          positionY += interlineadoRenglones;

          doc.setFontSize(7);
          doc.setFont(fontName, 'normal');
          // doc.setFontType('normal');

          doc.text(renglon.descripcion, 10, positionY);

          if (renglon.importe != 0) {
            doc.text(this.$options.filters.numero(renglon.importe, 2), 200, positionY, alignRight);
          }
        }
      }

      /* Total en letras */
      doc.setFont(fontName, 'normal');
      doc.setFontSize(7);
      // doc.setFontType('normal');
      doc.setTextColor(60, 60, 60);
      
      positionY = positionTotalesY + 20;
      let cadena = new String().concat('Son: pesos ', this.$options.filters.numeroALetras(venta.montoTotal));
      doc.text(cadena, 10, positionY);

      /* Totales  */
      positionY += 2;
      doc.line(10, positionY, 200, positionY);      

      positionY += interlineadoTotales;
      let positionLeyendaY = positionY;
      doc.text(`Forma de Pago: ${venta.formaPago}`, 10, positionY);

      if (venta.comprobanteTipoId == 17 || venta.comprobanteTipoId == 18
          || venta.comprobanteTipoId == 19 || venta.comprobanteTipoId == 21) {
        doc.setFont(fontBoldName, 'bold');
        doc.text('Total:', 140, positionY);
        doc.text(this.$options.filters.moneda(venta.montoTotal), 200, positionY, alignRight);
      } else {
        doc.text('Neto:', 140, positionY);
        doc.text(this.$options.filters.moneda(venta.montoGravado), 200, positionY, alignRight);
        positionY += interlineadoTotales;
        doc.text('Iva (19%):', 140, positionY);
        doc.text(this.$options.filters.moneda(venta.montoIvaInscripto), 200, positionY, alignRight);
        if (venta.montoExento != 0) {
          positionY += interlineadoTotales;
          doc.text('Exento:', 140, positionY);
          doc.text(this.$options.filters.moneda(venta.montoExento), 200, positionY, alignRight);
        }
        positionY += interlineadoTotales;
        doc.setFont(fontBoldName, 'bold');
        doc.text('Total:', 140, positionY);
        doc.text(this.$options.filters.moneda(venta.montoTotal), 200, positionY, alignRight);
      }

      drawFooter(doc, empresa, venta, fontName, fontBoldName, fontItalicName, fontBoldItalicName, positionLeyendaY);

      window.open(doc.output("bloburl", { filename: 'venta.pdf' } ));

      return;
    },
  }
}

function drawCabecera(doc, empresa, venta, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName) {
  let alignRight = {
    'align': 'right'
  }

  /* Verificamos si tiene logo asociado */
  let logoAsociado = (empresa.logoWeConnect.trim() != '')? true : false;

  drawCabeceraFiscalEmpresa({
    doc, 
    empresa, 
    fontName, 
    dark: false,
    logoAsociado
  });

  doc.setFontSize(10);
  // doc.setTextColor(232, 67, 113);
  doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
  
  let positionY = 18;
  if ((/true/i).test(logoAsociado)) {
    positionY = 40;
  }

  doc.text(`${venta.comprobanteTipo} Nº ${venta.numero.toString().trim()}`, 200, positionY, alignRight);
  doc.setTextColor(0, 0, 0);

  positionY += 5;
  doc.text(`Fecha: ${moment(venta.fechaComprobante).format('DD/MM/YYYY')}`, 200, positionY, alignRight);

  positionY = 56;
  if ((/true/i).test(logoAsociado)) {
    positionY = 61;
  }
  
  /* Giro de la venta */
  if (venta.comprobanteTipoId != 21) {
    doc.setFontSize(7);
    doc.setTextColor(151, 148, 149);
    doc.text(`Tipo de Venta: DEL GIRO`, 10, positionY);

    positionY += 4;
  }

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);
  doc.line(10, positionY, 200, positionY);
  
  /* Datos del cliente */
  doc.setFontSize(8);
  doc.setTextColor(60, 60, 60);

  positionY = positionY + 5;
  doc.text(`Cliente: ${venta.razonSocial.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`${venta.documentoTipo.trim()}: ${venta.documentoNumero.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Domicilio: ${venta.direccion.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Comuna: ${venta.localidad.trim()}`, 10, positionY);

  positionY += 4;
  if (venta.comprobanteTipoId == 21) {
    doc.text(`Giro: ${venta.giroEmpresa.trim()}`, 10, positionY);
  } else {
    doc.text(`Tipo de Compra: DEL GIRO`, 10, positionY);
  }

  positionY += 3;
  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);
  doc.line(10, positionY, 200, positionY);

  return positionY;
}

function drawFooter(doc, empresa, venta, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName, positionLeyendaY) {

  let alignRight = {
    'align': 'right'
  }

}

